import applySocketUpdates from 'modules/state/apply-socket-updates';
import createStore from './store';

export default createStore([applySocketUpdates]);



// WEBPACK FOOTER //
// ./app/gamma/src/defaultStore.ts